import { jsx } from "react/jsx-runtime";
import { SimonField } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
const BlockSimonField = ({
  attrs,
  index
}) => {
  const {
    type = "text",
    ...rest
  } = attrs;
  if (!attrs.name) {
    return null;
  }
  return /* @__PURE__ */ jsx(SimonField, { type, ...rest }, index);
};
BlockSimonField.propTypes = {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
};
export {
  BlockSimonField as default
};
